import type { UserResponse } from '@/repository/user.ts'

const userRepository = (fetch: CustomFetch) => ({
  async get(): Promise<UserResponse> {
    return fetch<UserResponse>('/v1/direct/user?v2=true')
  },
  async update(data: Partial<UserInfo & UserAttributes>) {
    await fetch('/v1/direct/user', {
      method: 'PUT',
      body: objectToSnakeCase(data),
    })
  },
  async getSignatureQualities(): Promise<SignatureQualities> {
    const signatureQualityData = await fetch<SignatureQualities>('/v3/direct/user/signature-qualities-detail')

    return {
      ...signatureQualityData,
      // FIXME: We are still using snake_case for seals
      seal: objectToSnakeCase(signatureQualityData.seal),
    }
  },
  async canJoinStarterPlan(businessId: string, srQuality: string, srId: string): Promise<boolean> {
    const response = await fetch<{ available: boolean }>(`/v2/starter-plan/show`, {
      method: 'POST',
      body: objectToSnakeCase({
        businessId,
        srQuality,
        srId,
      }),
    })
    return response.available
  },
  async starterSignup(registerData: StarterSignupPayload) {
    await fetch('/v3/businesses/convert/nas', {
      method: 'POST',
      body: objectToSnakeCase({
        firstName: registerData.firstName,
        lastName: registerData.lastName,
        password: registerData.password,
        gtc: registerData.isGtcAccepted,
        language: registerData.language,
        currency: registerData.currency,
      }),
    })
  },
})

export default userRepository
